<mat-toolbar>
  <span class="pointer" routerLink="/promotions"> PILOTAGE DES PROMOTIONS </span>
  <mat-icon class="">chevron_right</mat-icon>
  <span class="highlight">Détails de la promotion {{ informationPromotions?.idPromotion }}</span>

  <div class="container-listmatchip">
    @if (statusFilter && statusFilter.includes(selectedStatut)) {
    <mat-form-field class="status-form-field">
      <mat-select [(ngModel)]="selectedStatut" (selectionChange)="getStatutSelected($event)">
        <mat-select-trigger>
          <app-promotion-statut-chip
            [promotionStatut]="selectedStatut"
            [isDropDown]="true"
          ></app-promotion-statut-chip>
        </mat-select-trigger>

        <mat-option *ngFor="let statut of statusFilter" [value]="statut">
          <app-promotion-statut-chip [promotionStatut]="statut"></app-promotion-statut-chip>
        </mat-option>
      </mat-select>
    </mat-form-field>
    } @if (statusFilter && !statusFilter.includes(selectedStatut)) {
    <app-promotion-statut-chip [promotionStatut]="selectedStatut"></app-promotion-statut-chip>
    }
  </div>
</mat-toolbar>
<div class="">
  <app-promotions-info [promotionInfo]="informationPromotions"></app-promotions-info>
</div>

<div class="content">
  <mat-form-field appearance="outline" class="padding-x wide">
    <mat-icon matPrefix>search</mat-icon>
    <!--Champ de saisie pour la recherche-->
    <mat-label>Rechercher</mat-label>
    <input
      matInput
      [ngModel]="globalFilter"
      (ngModelChange)="applyFilter($event)"
      [placeholder]="'ean , désignation'"
      #input
    />
    <!-- Bouton pour réinitialiser la recherche -->
    <button
      mat-icon-button
      matSuffix
      class="padding-x"
      *ngIf="globalFilter"
      aria-label="Clear"
      (click)="applyFilter((globalFilter = ''))"
    >
      <mat-icon>close</mat-icon>
    </button>
  </mat-form-field>

  @if (listEanOrphelin && listEanOrphelin.length > 0) {
  <button
    mat-stroked-button
    class="padding-x"
    aria-label="Selected and in progress"
    ngClass="active"
    (click)="rattacherEanOrphelin()"
  >
    <mat-icon>add_link</mat-icon>Rattacher un code orphelin
  </button>
  }

  <button
    mat-stroked-button
    class="padding-x"
    aria-label="Selected and in progress"
    ngClass="active"
    (click)="generatePDF()"
  >
    <mat-icon>picture_as_pdf</mat-icon> Exporter en PDF
  </button>

  <table mat-table id="" [dataSource]="dataSource" matSort class="mat-elevation-z8">
    <!-- EAN -->
    <ng-container matColumnDef="dettacher">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let element">
        @if (element.flagEanOrphelin) {
        <button
          matTooltip="Détacher l'EAN"
          mat-icon-button
          aria-label="dettacher ean orphelin"
          (click)="dettacherEanOrphelin(element)"
        >
          <mat-icon>link_off</mat-icon>
        </button>
        }
      </td>
    </ng-container>

    <!-- EAN -->
    <ng-container matColumnDef="codeEan">
      <th mat-header-cell *matHeaderCellDef>Code EAN</th>
      <td mat-cell *matCellDef="let element">
        {{ element.eanOrphelin ? element.eanOrphelin : element.ean }}
      </td>
    </ng-container>

    <!-- Désignation -->
    <ng-container matColumnDef="designation">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Désignation</th>
      <td mat-cell *matCellDef="let element">
        {{ element.designationOrphelin ? element.designationOrphelin : element.designation }}
      </td>
    </ng-container>

    <!--tva-->
    <ng-container matColumnDef="tva">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>TVA</th>
      <td mat-cell *matCellDef="let element">
        {{ element.tvaOrphelin ? element.tvaOrphelin : element.tva }}
      </td>
    </ng-container>

    <!-- Quantité Vendue -->
    <ng-container matColumnDef="quantiteVendue">
      <th mat-header-cell *matHeaderCellDef>Quantité vendue</th>
      <td mat-cell *matCellDef="let element">{{ element.quantiteVendue }}</td>
    </ng-container>

    <!-- Montant Vendu -->
    <ng-container matColumnDef="montantVendu">
      <th mat-header-cell *matHeaderCellDef>Total SELL-OUT</th>
      <td mat-cell *matCellDef="let element">
        @if(element.montantVendu){
        {{ element.montantVendu | customNumberFormat }}
        &nbsp;€ }
      </td>
    </ng-container>

    <!-- Total Compensation Calculée -->
    <ng-container matColumnDef="totalCompensationCalculee">
      <th mat-header-cell *matHeaderCellDef>Total Compensation Calculée</th>
      <td mat-cell *matCellDef="let element">
        @if(element.montantCompensationCalculee) {
        {{ element.montantCompensationCalculee | customNumberFormat }}
        &nbsp;€ }
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr
      mat-row
      *matRowDef="let row; columns: displayedColumns"
      [ngClass]="{ 'flagged-row': row.flagEanOrphelin }"
    ></tr>

    <tr class="mat-row" *matNoDataRow>
      <td class="mat-cell center" colspan="12">
        Pas de details trouvées de cette promotion. Des filtres peuvent cacher certaines details.
      </td>
    </tr>
  </table>
</div>
